import { render, staticRenderFns } from "./JoinInfo.vue?vue&type=template&id=48ab937c&scoped=true"
import script from "./JoinInfo.vue?vue&type=script&lang=js"
export * from "./JoinInfo.vue?vue&type=script&lang=js"
import style0 from "./JoinInfo.vue?vue&type=style&index=0&id=48ab937c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ab937c",
  null
  
)

export default component.exports